import { handleError } from "@/utils/parseApiReturn";
import { ApiService } from "../../../config";

interface IUpdateUserProps {
  id: string;
  fullName: string;
  phone: string;
  email: string;
}

interface IGetUsersProps {
  page: number;
}

const getUsers = async ({ page }: IGetUsersProps): Promise<any> => {
  try {
    const response = await ApiService.get(`/support`, { page });

    return response.data;
  } catch (error) {
    handleError(error, "Erro ao tentar recuperar usuários:");
  }
};

const updateUser = async ({
  id,
  email,
  fullName,
  phone
}: IUpdateUserProps): Promise<any> => {
  try {
    const response = await ApiService.patch(`/users/${id}`, {
      fullName,
      phone,
      email
    });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.user;
  } catch (error: any) {
    handleError(error, "Erro ao atualizar usuário:");
    throw error;
  }
};

const searchUser = async (searchTerm: string): Promise<any> => {
  try {
    const response = await ApiService.get(`/support/search`, { searchTerm });

    return response.data.data;
  } catch (error) {
    handleError(error, "Erro ao procurar usuários:");
  }
};

const verifyUser = async (id: number): Promise<any> => {
  try {
    const response = await ApiService.patch(`/users/verify`, { id });

    return response.data.user;
  } catch (error) {
    handleError(error, "Erro ao verificar usuário:");
  }
};

export const SupportService = {
  getUsers,
  updateUser,
  searchUser,
  verifyUser
};
